var map = {
	"./black/paiduitongzhi.png": "70qr",
	"./blue/paiduitongzhi.png": "fvfp",
	"./white/paiduitongzhi.png": "deMC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UHUX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/paiduitongzhi\.png$
// module id = UHUX
// module chunks = 24